import NewEditCalendarioLetivoPage from "@/Pages/CalendarioLetivo/NewEditCalendarioLetivoPage.vue";
import { aplicarModulos } from "./modulos";

const rotas = [
  {
    path: "/calendario-letivo/create",
    name: "calendario-letivo.create",
    component: NewEditCalendarioLetivoPage,
    props: { editing: false },
  },
];

// Rota => módulo (Administração > Configurações).
const MODULO_POR_ROTA = {
  "calendario-letivo.create": "calendario",
};

export default aplicarModulos(rotas, MODULO_POR_ROTA);
